import styled from 'styled-components';
import { NavLink } from 'react-router-dom';
import { Wrapper } from 'components/Counter/styles'

export const Items = styled.div`

  display: flex;
  flex-direction: column;
  gap: 1.2rem;
  margin-top: 1.2rem;

`;

export const NavButton = styled(NavLink)`

  padding: .7rem;
  position: relative;

  ${Wrapper} {
    position: absolute;
    top: 0;
    right: 0;
  }
  
  &.active > svg > g > path {
    fill: #fff;
  }

`;